if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.onSubmitHandler = this.onSubmitHandler.bind(this);
        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.options = this.querySelectorAll('label');
        this.form.addEventListener('submit', this.onSubmitHandler);
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.quickAddSubmitButton = this.querySelector('.quick-add__submit');
        this.hideErrors = this.dataset.hideErrors === 'true';
        this.card = this.closest('.card--standard');
      }

      connectedCallback() {
        const isQuickAdd = !!(this.card && this.quickAddSubmitButton);
        const variantCount = isQuickAdd ? (parseInt(this.dataset.variantCount) || 0) : 0;
        const variantList = isQuickAdd ? this.querySelector('.collection_product_variant') : null;

        this.options.forEach(option => {
          option.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            const variantId = option.getAttribute('data_variant_id');
            if (!variantId) return;
            if (option.classList.contains('disabled')) return;
            this.form.querySelector('input[name="id"]').value = variantId;

            this.options.forEach(opt => opt.classList.remove('active'));
            option.classList.add('active');

            if (!isQuickAdd) {
              this.form.requestSubmit();
            } else if (variantCount > 1) {
              this.quickAddSubmitButton.disabled = false;
              this.quickAddSubmitButton.querySelector('span').textContent =
                this.quickAddSubmitButton.dataset.addText;
            } else if (variantCount === 1) {
              this.form.requestSubmit();
            }
          });
        });

        if (this.submitButton) {
          if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        if (isQuickAdd) {
          const productAvailable = !this.quickAddSubmitButton.disabled;

          this.quickAddSubmitButton.addEventListener('click', () => {
            if (variantList?.classList.contains('open')) {
              this.form.requestSubmit();
            } else {
              variantList?.classList.add('open');
              this.quickAddSubmitButton.setAttribute('aria-expanded', 'true');
              if (variantCount > 1) {
                this.quickAddSubmitButton.disabled = true;
                this.quickAddSubmitButton.querySelector('span').textContent =
                  this.quickAddSubmitButton.dataset.selectText;
              }
            }
          });

          this.card.addEventListener('mouseleave', () => {
            variantList?.classList.remove('open');
            this.options.forEach(opt => opt.classList.remove('active'));
            this.quickAddSubmitButton.setAttribute('aria-expanded', 'false');
            if (productAvailable) {
              this.quickAddSubmitButton.disabled = false;
              this.quickAddSubmitButton.querySelector('span').textContent =
                this.quickAddSubmitButton.dataset.addText;
            }
            const quickAddEl = this.closest('.quick-add');
            if (quickAddEl) quickAddEl.classList.remove('quick-add--added');
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        try {
          add_to_cart_fulling();
        } catch (e) {}

        let submitEventTriggerButton;

        // Determine which button triggered the submit event
        if(this.submitButton){
          submitEventTriggerButton = this.submitButton;
        } else if(this.quickAddSubmitButton){
          submitEventTriggerButton = this.quickAddSubmitButton;
        }

        if (submitEventTriggerButton.getAttribute('aria-disabled') === 'true') return;
        submitEventTriggerButton.setAttribute('aria-disabled', true);
        submitEventTriggerButton.classList.add('loading');
        if (this.quickAddSubmitButton && this.quickAddSubmitButton.dataset.addingText) {
          this.quickAddSubmitButton.querySelector('span').textContent =
            this.quickAddSubmitButton.dataset.addingText;
        }
        this.handleErrorMessage();

        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map(section => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = submitEventTriggerButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              submitEventTriggerButton.setAttribute('aria-disabled', true);
              submitEventTriggerButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            }
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => console.error(e))
          .finally(() => {
            submitEventTriggerButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) submitEventTriggerButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
            if (this.quickAddSubmitButton && !this.error) {
              const variantList = this.querySelector('.collection_product_variant');
              variantList?.classList.remove('open');
              this.quickAddSubmitButton.setAttribute('aria-expanded', 'false');
              this.quickAddSubmitButton.querySelector('span').textContent =
                this.quickAddSubmitButton.dataset.addText || this.quickAddSubmitButton.querySelector('span').textContent;
              const quickAddEl = this.closest('.quick-add');
              if (quickAddEl) quickAddEl.classList.add('quick-add--added');
            }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;

        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}